<res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [updateStatusType]="updateStatusType" [headerTemplate]="headerTemplate" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs" [requestInfo]="requestInfo"
    [contextMenuOptions]="contextMenuOptions" [responseArrayCallback]="responseArrayCallback"
    [cellDoubleClickedCallback]="cellDoubleClickedCallback" [rowClassRules]="rowClassRules" [pagerVisible]="false">
</res-generic-grid>
<ng-template #headerTemplate>
    <button type="button" data-automation-id="organization-settings-add-new-connector-button" class="secondary-button"
        (click)="addNewConnector()" [hidden]="hasConnectorViewOnlyPermissions">
        <i class="fa fa-plus"></i>New Connector...
    </button>
</ng-template>